var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'container-fluid': !_vm.isSettingsComponent}},[(!_vm.isSettingsComponent)?_c('apps-toolbar',{attrs:{"title":"Apps","icon":"fa-th-large"}}):_c('h2',[_vm._v("Installed Addon Apps")]),_c('addon-app-tab',{attrs:{"ui-location":"Main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }